import { queryKeys } from './useQueryAccountItemMetaType'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { useFetchAccountItemMetaType } from './useFetchAccountItemMetaType'
import { queryKeys as accountItemMetaQueryKeys } from '../account-item-meta/useQueryAccountItemMeta'

const create = () => {
  const { create } = useFetchAccountItemMetaType()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: create,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const update = () => {
  const { update } = useFetchAccountItemMetaType()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const drop = () => {
  const { drop } = useFetchAccountItemMetaType()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: drop,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([
        queryKeys.all(variables).queryKey,
        accountItemMetaQueryKeys.all(variables).queryKey,
      ])
    },
  })
}

export const useMutationAccountItemMetaType = {
  create,
  update,
  drop,
}
